define('views/modules/questionnaire/questions/list/question-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // custom
    'services/layout',
    // services
    'services/i18n',
    // views
    'views/parts/modal/modal',
    'views/parts/media-info-box',
    // templates
    'text!templates/modules/questionnaire/questions/list/question-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // custom
    LayoutState,
    // src
    i18n,
    // views
    VModal,
    VMediaInfoBox,
    // templates
    TQuestionListItem
) {

    var VQuestionListItem = Backbone.View.extend({
        template: TQuestionListItem,

        regions: {
            infobox: ".item-section",
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            var elementTypeIcon = "";
            var attributeType = this.model.attributes.type;

            if (attributeType === "text") elementTypeIcon = "fa fa-minus";
            if (attributeType === "textarea") elementTypeIcon = "fa fa-align-justify";
            if (attributeType === "number") elementTypeIcon = "fa fa-slack";
            if (attributeType === "date") elementTypeIcon = "fa fa-calendar";
            if (attributeType === "checkbox") elementTypeIcon = "fa fa-check-square-o";
            if (attributeType === "radio") elementTypeIcon = "fa fa-dot-circle-o";
            if (attributeType === "select") elementTypeIcon = "fa fa-list";

            this.view = {
                infobox: new VMediaInfoBox({
                    title: 'name',
                    model: this.model,
                    context: this,
                    onClick: this.onQuestionClick,
                    icon: elementTypeIcon,
                    menu: {
                        init: this.onMenuInit,
                        onClick: this.onActionClick,
                    }
                }),
            };

            this.listenTo(this.model, "remove", this.remove);
        },

        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.infobox, this.regions.infobox);
            // needs menu regions from infobox el

            return this;
        },

        deleteQuestion: function() {
            this.model.trigger("question:remove", this.model);
        },

        ////////////
        // events //
        ////////////

        onMenuInit: function() {
            var menuActions = new Backbone.Collection([
                { caption: 'Delete', icon: "sl-icon-trash", callback: this.onDeleteAction },
                { caption: 'Duplicate', icon: "sl-icon-docs", callback: this.onDuplicateAction },
            ]);

            return menuActions;
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onDeleteAction: function() {
            this.deleteQuestion();
        },

        onDuplicateAction: function() {
            this.model.trigger('question:duplicate', this.model);
        },

        onQuestionClick: function() {
            this.model.trigger("question:click", this.model);
        },

    });

    return VQuestionListItem;

});

